import React from "react";
import { Box, Breadcrumbs, Link, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import useRecipes from "../../../hooks/useRecipes";
import RecipeDetails from "./recipes/RecipeDetails";

const RecipeDetailPage = () => {
  const { orgId, recipeId } = useParams();
  const organizationId = orgId;
  const navigate = useNavigate();
  const { recipes, uploadImage } = useRecipes({ organizationId });

  const recipe = recipes.find((r) => r.id === recipeId);

  return (
    <Box
      sx={{
        marginTop: 1,
        display: "flex",
        flex: 1,
        flexDirection: "column",
        px: { xs: 2, sm: 3 },
      }}
    >
      <Box style={{ marginTop: 20 }}>
        <Breadcrumbs separator=">">
          <Link
            onClick={() => {
              window.scrollTo(0, 0);
              navigate("/home/recipes");
            }}
            style={{ cursor: "pointer" }}
          >
            Recipes
          </Link>
          <Typography>{recipe?.name || "Unknown Recipe"}</Typography>
        </Breadcrumbs>

        <Box style={{ marginTop: 20 }}>
          {recipes.length === 0 ? (
            <Typography>Loading recipes...</Typography>
          ) : (
            <RecipeDetails
              organizationId={organizationId}
              recipe={recipe}
              uploadImage={uploadImage}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default RecipeDetailPage;
